import React, {useState,useEffect} from 'react'
import DropDown from '../DropDown'
import { useHistory } from 'react-router'
import {Link,useLocation} from 'react-router-dom'
import { parse } from 'dotenv'

//el navbar ya direcciona a la pagina de busquedas
//falta maquetar la pagina de busquedas
export default function NavBar(props) {
	const {getSearch} = props
	const [search,setSearch] = useState("")
	const [key,setKey] = useState("")
	const history = useHistory();

	function handleSearch(event){
		setSearch(event.target.value)
	}
	function handleKey(event){
		if(event.key=="Enter"){
			history.push(`/search/${search}`)
			getSearch(search)
		}
		setKey(event.key)
	}

	const [isLogged,setIsLogged] = useState(false)
	const [username,setUsername] = useState("fulano")
	const [hamburger,setHamburger] = useState("d-none")
	function handleHamburger(){
		setHamburger(hamburger=="d-none"?"d-block":"d-none")
	}

	//terminamos el flujo del logeo
	useEffect(() => {
		if(localStorage.getItem('user-info')){
			const user_info = JSON.parse(localStorage.getItem('user-info'))
			console.log("la info de usuario es: ")
			console.log(user_info)
			setUsername(user_info.username)
			setIsLogged(true)

		}
	}, [])

    return (
		<>
<header className="fixed-top">
		<div className="container-xl custom-container">
			<div className="row">
				<div className="col-12">
					<nav className="navbar navbar-expand-lg navbar-light bg-light">
						<div className="navbar-left d-flex align-items-center">
							<button className="navbar-toggler d-flex d-md-none" type="button"
								data-toggle="collapse" data-target="#sidebar"
								aria-controls="navbarProfileInfo" aria-expanded="false"
								aria-label="Toggle navigation"
								onClick={setHamburger}
								>
								<span className="navbar-toggler-icon"></span>
							</button>
							<a href="/" className="site-logo" aria-label="DEV Community Home">
								<svg width="50" height="40" viewBox="0 0 50 40"
									xmlns="http://www.w3.org/2000/svg">
									<rect width="50" height="40" rx="3"> </rect>
									<path fill="white"
										d="M19.099 23.508c0 1.31-.423 2.388-1.27 3.234-.838.839-1.942 1.258-3.312 1.258h-4.403V12.277h4.492c1.31 0 2.385.423 3.224 1.27.846.838 1.269 1.912 1.269 3.223v6.738zm-2.808 0V16.77c0-.562-.187-.981-.562-1.258-.374-.285-.748-.427-1.122-.427h-1.685v10.107h1.684c.375 0 .75-.138 1.123-.415.375-.285.562-.708.562-1.27zM28.185 28h-5.896c-.562 0-1.03-.187-1.404-.561-.375-.375-.562-.843-.562-1.404V14.243c0-.562.187-1.03.562-1.404.374-.375.842-.562 1.404-.562h5.896v2.808H23.13v3.65h3.088v2.808h-3.088v3.65h5.054V28zm7.12 0c-.936 0-1.684-.655-2.246-1.965l-3.65-13.758h3.089l2.807 10.804 2.808-10.804H41.2l-3.65 13.758C36.99 27.345 36.241 28 35.305 28z">
									</path>
								</svg>
							</a>
						</div>
						{/*--aqui esta el input de busqueda--*/}
						<form className="seach" onSubmit={(e)=>e.preventDefault()}>
							<input id="search" className="form-control " onChange={handleSearch} onKeyPress={handleKey} value={search} type="search" placeholder="Search..."
								aria-label="Search..."/>
						</form>
						<div className="navbar-right d-flex  align-items-center">
						{isLogged?
							<>
							<Link to="/newpost" className="btn btn-primary btn-create-post d-none d-md-flex text-center"> Create Post
							</Link>
							<a href="vistaBusqueda.html" className="d-flex d-md-none"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" role="img" aria-labelledby="ah7a3pvabe7jbbaw3zw6bp1rlq45xhaj" className="crayons-icon"><title id="ah7a3pvabe7jbbaw3zw6bp1rlq45xhaj">Search</title>
    <path d="M18.031 16.617l4.283 4.282-1.415 1.415-4.282-4.283A8.96 8.96 0 0111 20c-4.968 0-9-4.032-9-9s4.032-9 9-9 9 4.032 9 9a8.96 8.96 0 01-1.969 5.617zm-2.006-.742A6.977 6.977 0 0018 11c0-3.868-3.133-7-7-7-3.868 0-7 3.132-7 7 0 3.867 3.132 7 7 7a6.977 6.977 0 004.875-1.975l.15-.15z"></path>
</svg></a>
							<a href=""><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" role="img" aria-labelledby="a3gbr0pjtet7mshwpsqehe7ud7dvkzgm" className="crayons-icon"><title id="a3gbr0pjtet7mshwpsqehe7ud7dvkzgm">Connect</title>
    <path d="M2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10H2l2.929-2.929A9.969 9.969 0 012 12zm4.828 8H12a8 8 0 10-8-8c0 2.152.851 4.165 2.343 5.657l1.414 1.414-.929.929zM8 13h8a4 4 0 11-8 0z"></path>
</svg></a>
							<a href=""><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" role="img" aria-labelledby="agp002jd6e75et7xc745ox53h2uxna32" className="crayons-icon"><title id="agp002jd6e75et7xc745ox53h2uxna32">Notifications</title>
    <path d="M20 17h2v2H2v-2h2v-7a8 8 0 1116 0v7zm-2 0v-7a6 6 0 10-12 0v7h12zm-9 4h6v2H9v-2z"></path>
</svg></a> 


							<div className="nav-item dropdown">

								<button id="navbarScrollingDropdown"
									className="nav-link dropdown-toggle profile-badge" type="button"
									data-toggle="dropdown" data-target="#navbarProfileInfoToggler"
									aria-controls="navbarSidebarToggler" aria-expanded="false"
									aria-label="Toggle navigation">
									<span className="circle-badge">
										<img className="crayons-avatar__image" alt="profile image"
											id="nav-profile-image"
											src="https://res.cloudinary.com/practicaldev/image/fetch/s--IjCb_ILa--/c_fill,f_auto,fl_progressive,h_90,q_auto,w_90/https://dev-to-uploads.s3.amazonaws.com/uploads/user/profile_image/647885/81bdd7eb-d4eb-4f9e-94a3-0ce06183465b.png"/>
									</span>
								</button>
								<ul className="dropdown-menu" aria-labelledby="navbarScrollingDropdown">

									<li>
										<a id="first-nav-link" href="#">

											<span className="fw-medium block">{username}</span>
											<small
												className="fs-s color-base-50">{"@"+username}</small>

										</a>
									</li>
									<li><a className="dropdown-item" href="#">Dashboard</a></li>
									<li><a className="dropdown-item" href="./New.html">Create Post</a></li>
									<li><a className="dropdown-item" href="#">Reading List </a></li>
									<li><a className="dropdown-item" href="#">Settings</a></li>
									<li>
										<hr className="dropdown-divider"/>
									</li>
									<li><a onClick={()=>{setIsLogged(false);localStorage.removeItem('user-info')}} className="dropdown-item" href="#">Sign Out</a></li>
								</ul>
							</div>
						</>:<>
							<Link to="/login" className="bg-light text-primary btn btn-primary border border-light btn-create-post d-none d-md-flex text-center">Log in
							</Link>
							<Link to="/signin" className="btn btn-primary btn-create-post d-none d-md-flex text-center"> Create account
							</Link>
						</>}
						</div>

					</nav>
				</div>
			</div>
		</div>
        <DropDown visible={hamburger}/>
	</header>

	</>
    
    )
}
